// Types
import type { TTableHeaders } from '~/misc/v-table/types';

const TABLE_HEADERS: TTableHeaders = [
  'Address',
  'Type',
  'Status',
  'Current Price',
  'Original Price',
  'Reduced At',
  'Under Offer At',
  'SSTC At',
  'Listed At',
  'Listing Url',
  'Agent Name',
];

export { TABLE_HEADERS };
